<template>
    <div class="product-price-box">
        <div v-if="product">
            <div class="price-rating-container">
                <div class="price hd-16 bold">HK${{ priceApp }}</div>
                <div class="price-original hd-14" v-if="priceOriginal && priceOriginal > 0"><del>HK${{ priceOriginal }}</del></div>
            </div>
            <div class="hd-12" style="color: #52616B; margin-bottom: 8px">{{ $t('web.travel-product.product-option')}}</div>
            <div class="field" v-bind:class="{'is-hidden' : product.packages && product.packages.length == 1}">
                <div class="control">
                    <div class="select">
                        <select v-model="form.packageId">
                            <option v-for="p in product.packages" :value="p.id">{{ p.name }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="field" v-if="selectedPackage"  v-bind:class="{'is-hidden' : selectedPackage && selectedPackage.quantity_options && selectedPackage.quantity_options.length == 1}">
                <div class="control">
                    <div class="select">
                        <select v-model="form.optionId">
                            <option v-for="option in selectedPackage.quantity_options" :value="option.id">{{ option.title }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="field" v-if="selectedOption">
                <div class="control">
                    <div class="select">
                        <select v-model="form.quantity">
                            <option v-for="i in Array.from(Array(10).keys())" :value="i + 1">{{ i + 1 }}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="field" style="margin-top: 32px">
                <div class="control">
                    <a v-if="!product.is_sold_out" :href="checkoutUrl" class="button is-block is-black">{{ $t('web.travel-product.buy-now')}}</a>
                    <a v-else href="#" class="button is-block is-black" disabled="">{{ $t('web.travel-sim.no-stock') }}</a>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
    import axios from "axios";

    export default {
        props: {
            apiDomain: String,
            productId: String,
            checkoutRoute: String,
            locale: String
        },

        data(){
            return {
                product: null,
                form: {
                    packageId: null,
                    optionId: null,
                    quantity: 1
                }
            }
        },

        computed: {
            priceApp(){
                let price = this.product.min_price;
                if(this.selectedOption){
                    price = this.selectedOption.price * this.form.quantity
                }
                return price;
            },
            priceOriginal(){
                let price = this.product.min_price;
                if(this.selectedOption){
                    price = this.selectedOption.price_original * this.form.quantity
                }
                return price;
            },
            selectedPackage(){
                if(!this.product) return null;
                return this.product.packages.find(p => p.id == this.form.packageId);
            },
            selectedOption(){
                if(!this.selectedPackage) return null;
                return this.selectedPackage.quantity_options.find(o => o.id == this.form.optionId);
            },
            checkoutUrl(){
                let url = this.checkoutRoute;
                url = url + `/checkout?productId=${this.product.id}&packageId=${this.selectedPackage.id}&optionId=${this.selectedOption.id}&quantity=${this.form.quantity}`
                return url;
            }
        },

        async mounted() {
            let locale = "en-US";
            if(this.locale === "zh-TW" || this.locale === "zh-CN" || this.locale === "zh-HK"){
                locale = "zh-HK";
            }
            this.product = (await axios.get(window.location.protocol + "//" + this.apiDomain + "/api/v1/products/" + this.productId, {
                headers: { 'App-Locale': locale }
            })).data.data;
            try {
                this.$set(this.form, 'packageId', this.product.packages[0].id);
                this.$set(this.form, 'optionId', this.product.packages[0].quantity_options[0].id);
            }catch (e) {
                
            }
        }
    }
</script>